export default __webpack_public_path__ + "static/media/logo-google.39c52b1b.png";